import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import spacing from '../spacing';
import breakpoints from '../breakpoints';

const CUSTOM_PROPS = ['maxWidth', 'disableGutters', 'fluid'];

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => !CUSTOM_PROPS.includes(prop),
})(({ maxWidth, disableGutters, fluid }) => {
  const maxWidths = {
    xs: 444,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  };

  return {
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    boxSizing: 'border-box',
    
    ...(!fluid && {
      maxWidth: maxWidth ? maxWidths[maxWidth] : maxWidths.lg,
    }),
    
    ...(!disableGutters && {
      paddingLeft: spacing[4],
      paddingRight: spacing[4],
      
      [breakpoints.up('sm')]: {
        paddingLeft: spacing[6],
        paddingRight: spacing[6],
      },
      
      [breakpoints.up('md')]: {
        paddingLeft: spacing[8],
        paddingRight: spacing[8],
      },
    }),
  };
});

const Container = ({
  children,
  maxWidth = 'lg',
  disableGutters = false,
  fluid = false,
  component = 'div',
  ...props
}) => {
  return (
    <StyledContainer
      as={component}
      maxWidth={maxWidth}
      disableGutters={disableGutters}
      fluid={fluid}
      {...props}
    >
      {children}
    </StyledContainer>
  );
};

export default Container;
